import { Badge, Stack, Group, Textarea } from "@mantine/core"
import { Form } from "../../../../../-components/typed-form"
import { TimeInput } from "@mantine/dates"
import { CancelButton, SubmitButton } from "../../../../../-components/Buttons"
import { DateOnly, Nullable, TimeOnly } from "../../../../../@client/System"
import { useTranslation } from "react-i18next"
import { useSuspenseQueryGet } from "../../../../../typed-client/hooks/use-suspense-query-get"
import { timeOnlyToMantineTime } from "../../../../../utils/time-only-to-mantine-time"
import { mapNullable } from "../../../../../utils/nullable"
import { useBatchedShiftTypes } from "../../../../../-dataloaders/shift-types"
import { ts_Schicht } from "../../../../../@client/Theasoft_DataClasses_Perso"
import { match } from "ts-pattern"

export function EditShiftModal({
  departmentId,
  dutyRosterId,
  shiftId,
  onCancel,
  contractId,
  date,
  onEdited,
}: {
  departmentId: number
  contractId: number
  date: DateOnly
  dutyRosterId: number
  shiftId: ts_Schicht
  onCancel: () => void
  onEdited?: () => void
}) {
  const { t } = useTranslation("app_server")
  const { data: availablePresenceShiftTypes } = useSuspenseQueryGet(
    "/api/ShiftType/GetRequestablePresenceShiftTypesForDepartment",
    { departmentId }
  )

  const { data: shift } = useSuspenseQueryGet(
    "/api/DepartmentDutyRoster/GetShift",
    {
      dutyRosterId,
      shiftId,
    }
  )
  const rawShiftId = match(shiftId)
    .with("Schicht1", () => 1)
    .with("Schicht2", () => 2)
    .with("Schicht3", () => 3)
    .exhaustive()
  const { data: shiftType } = useBatchedShiftTypes(shift.shiftTypeId)

  if (!shift) {
    return null
  }

  const readOnly = !availablePresenceShiftTypes.some(
    (st) => st.shiftTypeId === shift.shiftTypeId
  )

  return (
    <Form
      key={JSON.stringify(shift)}
      url="/api/DepartmentDutyRoster/EditShift"
      onSuccess={() => {
        onEdited && onEdited()
      }}
      initialValues={{
        startTime: mapNullable(shift.startTime, timeOnlyToMantineTime),
        endTime: mapNullable(shift.endTime, timeOnlyToMantineTime),
        note: shift.shiftNote,
        shiftTypeId: shift.shiftTypeId,
      }}
      transform={(x) => ({
        contractId,
        date,
        dutyRosterId,
        shiftId: rawShiftId,
        shiftTypeId: x.shiftTypeId,
        shiftNote: x.note,
        startTime: mapNullable(
          x.startTime,
          (x) => x + ":00"
        ) as Nullable<TimeOnly>,
        endTime: mapNullable(x.endTime, (x) => x + ":00") as Nullable<TimeOnly>,
      })}
    >
      {(f, _) => (
        <>
          <Stack>
            <Badge>
              {t("Type")} {shiftType?.name}
            </Badge>
            <Group>
              <TimeInput
                readOnly={readOnly}
                {...f.getInputProps(_.startTime._PATH_)}
                label={t("From")}
              />
              <TimeInput
                readOnly={readOnly}
                {...f.getInputProps(_.endTime._PATH_)}
                label={t("Until")}
              />
            </Group>
            <Textarea
              readOnly={readOnly}
              {...f.getInputProps(_.note._PATH_)}
              label={t("Note")}
            />
            <Group justify="end">
              <CancelButton onMouseDown={() => onCancel()} />
              <SubmitButton disabled={readOnly}>
                {t("UpdateShift")}
              </SubmitButton>
            </Group>
          </Stack>
        </>
      )}
    </Form>
  )
}
